// Mutations
export const RESETDESTINATIONS = 'RESETDESTINATIONS'
export const BINDDESTINATIONS = 'BINDDESTINATIONS'
export const UNBINDDESTINATIONS = 'UNBINDDESTINATIONS'

// Actions
export const ADDDESTINATION = 'ADDDESTINATION'
export const EDITDESTINATION = 'EDITDESTINATION'
export const DELETEDESTINATION = 'DELETEDESTINATION'
export const SELECTDESTINATION = 'SELECTDESTINATION'

import db from '../../firebase/firebase'
import router from '../../router/router'
import {
  addBoundReversed,
  bindArray,
  removeBound,
  updateBoundObj } from '../helpers/binding';
import { compareByName, localStorageSetKeyOrRemove } from '../../functions/general'
import { generateUpdatesForObject } from '../helpers/updates'
import {
  BINDLOCKOUTS,
  DELETELOCKOUT,
  RESETLOCKOUTS,
  UNBINDLOCKOUTCONTENT,
  UNBINDLOCKOUTS } from './lockouts'
import { RESETATTENDANCE } from './attendance'
import { RESETSIGNUPS } from './signups'
import { RESETRAIDEVENTS } from './raidevents'
import { RESETTEAMS } from './teams'

import rolesJson04 from '../../config/templates/04/roles.json'
import specsJson04 from '../../config/templates/04/specs.json'
import rolesJson37 from '../../config/templates/37/roles.json'
import specsJson37 from '../../config/templates/37/specs.json'
import rolesJson43 from '../../config/templates/43/roles.json'
import specsJson43 from '../../config/templates/43/specs.json'
import { getSpecSortSequence } from '../../functions/rolespecfunctions'

export default {
  state: () => ({
    destinations: [],
    selectedDestination: null,
    roles: [],
    specs: [],
    roles04: rolesJson04,
    specs04: specsJson04,
    roles37: rolesJson37,
    specs37: specsJson37,
    roles43: rolesJson43,
    specs43: specsJson43,
  }),

  getters: {
    // getSpecDisplayName: ( state ) => ( spec ) => {
    //   const obj = state.specs.find(s => s.name == spec);
    //   if (obj && obj.displayname) return obj.displayname;
    //   return spec;
    // },

    getSpecCSSClass: ( state ) => ( spec ) => {
      const obj = state.specs.find(s => s.name == spec);
      if (obj ) return obj.cssclass;
      return '';
    },
    
    getClassCSSClass: ( state ) => ( classname ) => {
      const obj = state.specs.find(s => s.classname == classname);
      if (obj) return obj.cssclass;
      return '';
    },
    
    getSpecIcon: ( state ) => ( spec ) => {
      const obj = state.specs.find(s => s.name == spec);
      if (obj) return obj.icon;
      return '';
    },
    
    getSpecWowHeadRaidCompID: ( state ) => ( spec ) => {
      const obj = state.specs.find(s => s.name == spec);
      if (obj) return obj.wowheadraidcompid;
      return '';
    },
    
    getSpecClass: ( state ) => ( spec ) => {
      const obj = state.specs.find(s => s.name == spec);
      if (obj) return obj.classname;
      return '';
    },
    
    getSpecRole: ( state ) => ( spec ) => {
      // Lookup the spec in the roles JSON
      for (const role of state.roles) if (role.specs.findIndex(s => s == spec) != -1) return role.name;
      return '';
    },

    isSignupForRole: ( state ) => (signup, container) => {
      let specRole = ''
      for( const role of state.roles) if (role.specs.findIndex(s => s == signup.spec) != -1) specRole = role.name;

      return specRole == container.role.name
        && signup.eventid == container.raidevent['.key']    // Events match
        && (signup.state == container.state             // States match
          || signup.state == null
          && container.state == 'Unplanned')
        && (container.team == null                     // Team match
          || signup.team == container.team['.key'])
    },
    
    compareSignupsBySpecAndName: (state) => (a, b) => {
      const specseqa = getSpecSortSequence(state.specs, a.spec);
      const specseqb = getSpecSortSequence(state.specs, b.spec);
      if (specseqa < specseqb) {
        return -1;
      }
      if (specseqa > specseqb) {
        return 1;
      }
      return compareByName(a, b);
    },

    compareByGroups: (state) => ( a, b ) => {
      if( a.group && !b.group || a.group < b.group ) return -1
      if( !a.group && b.group || a.group > b.group ) return 1
      const specseqa = getSpecSortSequence(state.specs, a.spec);
      const specseqb = getSpecSortSequence(state.specs, b.spec);
      if (specseqa < specseqb) {
        return -1;
      }
      if (specseqa > specseqb) {
        return 1;
      }
      return compareByName(a, b);
    },
    
  },

  mutations: {
    addBoundDestination: ( state, { snapshot } ) => addBoundReversed( state.destinations, snapshot ),
    removeBoundDestination: ( state, { snapshot } ) => removeBound( state.destinations, snapshot ),
    updateBoundDestination: ( state, { snapshot } ) => updateBoundObj( state.destinations, snapshot ),

    setSelectedDestination( state, destination ) {
      state.selectedDestination = destination
      if( destination ) {
        const raideventtemplate = destination.raideventtemplate && ['04','37','43'].includes(destination.raideventtemplate) ? destination.raideventtemplate : '04'
        state.roles = state['roles' + raideventtemplate]
        state.specs = state['specs' + raideventtemplate]
      }

      // Remember last selected destination in localStorage
      localStorageSetKeyOrRemove( 'lastSelectedDestination', destination )
    },

    [RESETDESTINATIONS] ( state ) {
      state.destinations = []
      state.selectedDestination = null
      state.roles = []
      state.specs = []
    },
  },

  actions: {
    [BINDDESTINATIONS] ( { commit }, guild ) {
      const destsRef = db.ref( 'guildDestinations/' +
                               guild['.key'] + '/destinations' )
      bindArray( destsRef, commit, 'Destination')
    },
    [UNBINDDESTINATIONS] ( { rootState } ) {
      let guild = rootState.guilds.selectedGuild
      if( guild ) {
        const destsRef = db.ref( 'guildDestinations/' +
                                 guild['.key'] + '/destinations' )
        destsRef.off()
      }
    },

    [ADDDESTINATION] ( context, { guild, destination } ) {
      if( guild ) {
        db.ref( 'guildDestinations/' +
                guild['.key'] + '/destinations' ).push( destination )
      }
    },
    [EDITDESTINATION] ( context, { guild, destination, newvalues } ) {
      if( guild && destination ) {
        let updates = generateUpdatesForObject(
          'guildDestinations/' + guild['.key'] +
          '/destinations/' + destination['.key'] + '/', newvalues )
        return db.ref().update( updates )
      }
    },
    async [DELETEDESTINATION] ( { dispatch }, { guild, destination } ) {
      if( guild && destination ) {
        // First delete all the lockouts
        let lockoutsSnapshot = await db.ref( 'destinationLockouts/' +
                                             destination['.key'] +
                                             '/lockouts/' ).get()
        let lockouts = lockoutsSnapshot.val()

        for( let lockoutKey in lockouts ) {
          let lockout = lockouts[ lockoutKey ]
          Object.defineProperty( lockout, '.key', { value: lockoutKey, enumerable: false } )

          await dispatch( DELETELOCKOUT, { destination, lockout } )
        }

        let updates = {}
        updates[ 'guildDestinations/' + guild['.key'] 
                 + '/destinations/' + destination['.key'] ] = null
        updates[ 'destinationAttendance/' 
                 + destination['.key'] ] = null

        return db.ref().update( updates )
      }
    },
    
    async [SELECTDESTINATION] ( { commit, dispatch }, destination ) {
      await dispatch( UNBINDLOCKOUTCONTENT )
      await dispatch( UNBINDLOCKOUTS )

      if( !destination ) commit( 'setSelectedLockout', null )
      
      commit( RESETSIGNUPS )
      commit( RESETRAIDEVENTS )
      commit( RESETTEAMS )
      commit( RESETATTENDANCE )
      commit( RESETLOCKOUTS )

      commit( 'setSelectedDestination', destination )
      
      if( destination ) {
        dispatch( BINDLOCKOUTS, destination )
      }
      router.push( '/roster' )
    },

  },
}